let SportConfig = {
    GET_SPORT_CONFIG_REQUEST: 'GET_SPORT_CONFIG_REQUEST',
    GET_SPORT_CONFIG_SUCCESS: 'GET_SPORT_CONFIG_SUCCESS',
    GET_SPORT_CONFIG_FAILURE: 'GET_SPORT_CONFIG_FAILURE',

    UPDATE_MAX_SALARY: 'UPDATE_MAX_SALARY',

    FILTER_BY_SPORT: 'FILTER_BY_SPORT',
    FILTER_BY_SITE: 'FILTER_BY_SITE',
    FILTER_BY_GAME_TYPE: 'FILTER_BY_GAME_TYPE',
    FILTER_BY_SLATE: 'FILTER_BY_SLATE',
    FILTER_BY_MODE: 'FILTER_BY_MODE',

    LEAGUE_NFL: 'nfl',
    LEAGUE_NBA: 'nba',
    LEAGUE_GOLF: 'golf',
    LEAGUE_NASCAR: 'nascar',
    LEAGUE_MMA: 'mma',
    LEAGUE_MLB: 'mlb',
    LEAGUE_NHL: 'nhl',
    LEAGUE_CFB: 'cfb',
    LEAGUE_LOL: 'lol',
    LEAGUE_TENNIS: 'tennis',
    LEAGUE_F1: 'f1',

    SITE_DK: 'draftkings',
    SITE_FD: 'fanduel',
    SITE_YAHOO: 'yahoo',

    GAME_TYPE_CLASSIC: 'classic',
    GAME_TYPE_TIERS: 'tiers',
    GAME_TYPE_SHOWDOWN: 'showdown',
    GAME_TYPE_SINGLEGAME: 'single-game',

    MODE_MAIN: 'main',
    MODE_BACKTEST: 'backtest',
    MODE_LATESWAP: 'lateswap',

    MLB_FD_POSITION_1B: '1B',
    MLB_FD_POSITION_C: 'C',
    MLB_FD_POSITION_1BC: 'C/1B',

    NBA_DK_POSITION_G: 'G',
    NBA_DK_POSITION_F: 'F',

    NBA_DK_POSITION_GF: 'G/F',
    NBA_DK_POSITION_FC: 'F/C',

    POSITION_UTIL: 'UTIL',
    POSITION_FLEX: 'FLEX',
    POSITION_SUPERFLEX: 'SUPERFLEX',
    POSITION_STAR: 'STAR - 1.5X Points',
    POSITION_DEF: 'DEF',
    POSITION_CFB_NAMES: {
        draftkings: {
            SUPERFLEX: 'S-FLEX',
        },
        fanduel: {
            SUPERFLEX: 'Super FLEX',
        },
    },

    MAIN_SPORTS: ['nba', 'nfl', 'cfb', 'mlb', 'nhl', 'golf', 'nascar', 'mma', 'lol', 'tennis', 'f1'],
    BACKTEST_SPORTS: ['nba', 'nfl', 'cfb', 'mlb', 'nhl', 'golf', 'nascar', 'mma', 'tennis', 'f1'],
    LATESWAP_SPORTS: ['cfb', 'mlb', 'nba', 'nfl'],

    NFL_PASS_RECEIVER_POSITIONS: ['WR', 'TE'],

    MODES_CONFIG_INIT: 'MODES_CONFIG_INIT',

    DRAFTKINGS_MIN_ADJUSTED_PLAYERS: 2,
};

SportConfig.MODES = {
    [SportConfig.MODE_MAIN]: 'Main',
    [SportConfig.MODE_LATESWAP]: 'Late Swap',
    [SportConfig.MODE_BACKTEST]: 'Backtest',
};

SportConfig.MODE_SPORTS_MAP = {
    [SportConfig.MODE_MAIN]: SportConfig.MAIN_SPORTS,
    [SportConfig.MODE_LATESWAP]: SportConfig.LATESWAP_SPORTS,
    [SportConfig.MODE_BACKTEST]: SportConfig.BACKTEST_SPORTS,
};

export default SportConfig;
